/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { FailedNotificationDto } from '../model/failedNotificationDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class AdminFailedNotificationsService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param status 
     * @param entityType 
     * @param notificationType 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFailedNotifications(status?: 'FAILED' | 'RESOLVED', entityType?: 'ORDER' | 'RMA', notificationType?: 'ORDER_READY_FOR_CONFIGURATION' | 'ORDER_ITEM_SUBMITTED_FOR_REVIEW' | 'ORDER_ITEM_MOVED_TO_PRODUCTION' | 'ORDER_SHIPPED' | 'ORDER_REMINDER_DUE' | 'RMA_SUBMITTED_BY_CUSTOMER' | 'RMA_QUOTE_REQUIRED' | 'RMA_PACKAGE_RECEIVED' | 'RMA_DEVICE_DATA_AVAILABLE' | 'RMA_INSPECTION_COMPLETED' | 'RMA_ADDED_BY_ADMIN', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<FailedNotificationDto>>;
    public getFailedNotifications(status?: 'FAILED' | 'RESOLVED', entityType?: 'ORDER' | 'RMA', notificationType?: 'ORDER_READY_FOR_CONFIGURATION' | 'ORDER_ITEM_SUBMITTED_FOR_REVIEW' | 'ORDER_ITEM_MOVED_TO_PRODUCTION' | 'ORDER_SHIPPED' | 'ORDER_REMINDER_DUE' | 'RMA_SUBMITTED_BY_CUSTOMER' | 'RMA_QUOTE_REQUIRED' | 'RMA_PACKAGE_RECEIVED' | 'RMA_DEVICE_DATA_AVAILABLE' | 'RMA_INSPECTION_COMPLETED' | 'RMA_ADDED_BY_ADMIN', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<FailedNotificationDto>>>;
    public getFailedNotifications(status?: 'FAILED' | 'RESOLVED', entityType?: 'ORDER' | 'RMA', notificationType?: 'ORDER_READY_FOR_CONFIGURATION' | 'ORDER_ITEM_SUBMITTED_FOR_REVIEW' | 'ORDER_ITEM_MOVED_TO_PRODUCTION' | 'ORDER_SHIPPED' | 'ORDER_REMINDER_DUE' | 'RMA_SUBMITTED_BY_CUSTOMER' | 'RMA_QUOTE_REQUIRED' | 'RMA_PACKAGE_RECEIVED' | 'RMA_DEVICE_DATA_AVAILABLE' | 'RMA_INSPECTION_COMPLETED' | 'RMA_ADDED_BY_ADMIN', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<FailedNotificationDto>>>;
    public getFailedNotifications(status?: 'FAILED' | 'RESOLVED', entityType?: 'ORDER' | 'RMA', notificationType?: 'ORDER_READY_FOR_CONFIGURATION' | 'ORDER_ITEM_SUBMITTED_FOR_REVIEW' | 'ORDER_ITEM_MOVED_TO_PRODUCTION' | 'ORDER_SHIPPED' | 'ORDER_REMINDER_DUE' | 'RMA_SUBMITTED_BY_CUSTOMER' | 'RMA_QUOTE_REQUIRED' | 'RMA_PACKAGE_RECEIVED' | 'RMA_DEVICE_DATA_AVAILABLE' | 'RMA_INSPECTION_COMPLETED' | 'RMA_ADDED_BY_ADMIN', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>status, 'status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>entityType, 'entityType');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>notificationType, 'notificationType');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/admin/failed-notifications`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<FailedNotificationDto>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resend(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public resend(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public resend(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public resend(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling resend.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/admin/failed-notifications/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/resend`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
